import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import React from 'react'

const Twitter = ({ desc, image, title, type, username }) => (
  <Helmet>
    <meta name='twitter:card' content={type} />
    <meta name='twitter:description' content={desc} />
    <meta name='twitter:image' content={image} />
    <meta name='twitter:image:alt' content={desc} />
    <meta name='twitter:title' content={title} />
    {username && <meta name='twitter:creator' content={username} />}
  </Helmet>
)

export default Twitter

Twitter.propTypes = {
  desc: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  username: PropTypes.string,
}

Twitter.defaultProps = {
  type: 'summary_large_image',
  username: null,
}
